import { browser } from "$app/environment";

export const businessId = "54f5f5ad0000ff00057dce30";
export const reviewUrl = "https://uk.trustpilot.com/review/footballticketpad.com";

const trustPilotSrc = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
export function loadTrustpilot(script: HTMLScriptElement) {
  if (!browser) {
    return;
  }

  const el = document.getElementById("trustpilot-script");
  if (el) {
    (window.Trustpilot as any)?.Modules?.WidgetManagement?.initializeOnPageLoad();
    return;
  }
  // unloadTrustpilot(script);
  script = document.createElement("script");
  script.id = "trustpilot-script";
  script.src = trustPilotSrc;
  script.type = "text/javascript";
  script.async = true;
  document.body.appendChild(script);
}

export function unloadTrustpilot(script: HTMLScriptElement) {
  if (!browser) {
    return;
  }

  // if (script) {
  //   document.body.removeChild(script);
  // }

  // const existing = document.getElementById("trustpilot-script");
  // if (existing) {
  //   document.body.removeChild(existing);
  // }

  // if (window?.Trustpilot) {
  //   delete window.Trustpilot;
  // }
}
